/* eslint-disable sort-keys-fix/sort-keys-fix */
import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.group-sessions': {
         groupSessions: 'Terapie grupowe',
         noGroupSessionsAddedYet: 'Nie dodano jeszcze żadnej grupy terapeutycznej',
         noGroupSessionsCreated: 'Brak utworzonych grup terapeutycznych',
         name: 'Nazwa',
         fillName: 'Uzupełnij nazwę..',
         type: 'Rodzaj',
         practitioners: 'Prowadzący',
         service: 'Usługa',
         scheduleDays: 'Harmonogram',
         placesLimit: 'Limit miejsc',
         serviceProvidingLocationAbbreviation: 'MUŚ',
         serviceProvidingLocation: 'Miejsce udzielania świadczeń',
         status: 'Status grupy',
         groupSessionsStatusMap: {
            DRAFT: 'W przygotowaniu',
            READY: 'Do uruchomienia',
            ACTIVE: 'Aktywna',
            COMPLETED: 'Zakończona',
            CANCELLED: 'Anulowana',
         },
         groupSessionsTypeMap: {
            CLOSED: 'Zamknięta',
            SEMI_CLOSED: 'Półzamknięta',
            OPEN: 'Otwarta',
         },
         groupNote: 'Notatka do grupy',
         participantAge: 'Wiek uczestnika',
         participantsAgeRange: '{{ minAge }} - {{ maxAge }} lat',
         minParticipantsWarning: 'Min. {{ minParticipantsCount }}',
         createTherapeuticGroup: 'Dodaj grupę terapeutyczną',
         ageRestrictionEnabled: 'Określ wiek uczestnika',
         minParticipants: 'Minimalna liczba uczestników',
         maxParticipants: 'Maksymalna liczba uczestników',
         minAge: 'Minimalny wiek',
         maxAge: 'Maksymalny wiek',
         displayName: 'Imię i nazwisko',
         specialties: 'Specjalizacje',
         noPractitioners: 'Brak przypisanych prowadzących',
         noSpecialties: 'Brak specjalizacji',
         assignPractitioner: 'Przypisz prowadzącego',
         practitionersDeclensionMap: {
            accusative: 'prowadzącego',
            genitive: 'prowadzących',
            plural: 'prowadzących',
         },
         saveAndAddAnother: 'Zapisz i dodaj kolejną',
         noteForGroup: 'Notatka dla grupy',
         addNoteForGroup: 'Dodaj notatkę dla grupy',
         fillNote: 'Uzupełnij treść notatki...',
         receptionService: 'Usługa recepcyjna',
         chooseReceptionService: 'Wybierz usługę recepcyjną...',
         billingService: 'Usługa rozliczeniowa',
         chooseBillingService: 'Wybierz usługę rozliczeniową...',
         fetchDataErrorOccurredDuringTherapeuticGroupCreation:
            'Wystąpił błąd pobierania danych na potrzeby tworzenia grupy terapeutycznej.',
         successfullyCreatedTherapeuticGroup: 'Pomyślnie utworzono grupę terapeutyczną.',
         practitionerHasNoAssignedReceptionService:
            '{{practitionerName}} nie ma przypisanej wybranej usługi recepcyjnej.',
         practitionerHasNoAssignedMedicalService:
            '{{practitionerName}} nie ma przypisanej wybranej usługi rozliczeniowej.',
         fetchError: 'Nie udało się pobrać danych, spróbuj ponownie',
         chooseHealthcareProviderLocation: 'Wybierz Miejsce Udzielania Świadczeń',
         healthcareProviderLocation: 'Miejsce Udzielania Świadczeń',
         schedule: 'Harmonogram',
         day: 'Dzień',
         hours: 'Godziny',
         chooseAll: 'Wybierz wszystkie',
         timeOfDayMap: {
            MORNING: 'do 12:00',
            AFTERNOON: '12:00-17:00',
            EVENING: 'po 17:00',
         },
         instructor: 'Prowadzący',
         chooseInstructors: 'Wybierz prowadzących',
         chosenOptions: 'Wybrano {{count}} z {{totalCount}}',
         scheduleFilterDeselectorLabel: '{{dayOfWeek}}: {{timeOfDay}}',
         noService: 'Brak usługi',
         chooseServices: 'Wybierz usługi',
         chooseStatus: 'Wybierz status',
         chosenGroupType: 'Wybrany rodzaj grupy',
         chooseGroupType: 'Wybierz rodzaj grupy',
         groupType: 'Rodzaj grupy',
         occupancyMap: {
            FULL: 'Pełna',
            HAS_VACANCIES: 'Ma wolne miejsca',
         },
         groupOccupancy: 'Obłożenie grupy',
         chooseOccupancy: 'Wybierz obłożenie',
         issuesMap: {
            NO_SCHEDULE: 'Brak harmonogramu',
            NO_PRACTITIONER: 'Brak prowadzącego',
            BELOW_MINIMUM_OCCUPANCY: 'Obłożenie poniżej minimum',
         },
         needsAttention: 'Wymaga uwagi',
         chooseElementToCheck: 'Wybierz element do sprawdzenia',
         noMatchingResults: 'Brak pasujących wyników',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.group-sessions');
